import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import { useAxios, useComponent } from "../../hooks";
import Form from "./details components/Form";
import PageHeader from "../../components/PageHeader";
import {
  objectFromResponseData,
  workflowObject,
} from "./details components/workflowObject";
import { Loader } from "../../components";

export default function WorkflowDetails() {
  const axios = useAxios();
  const { loader } = useComponent();
  const { workflowID } = useParams();
  const [editState, setEditState] = useState(true);
  const [formData, setFormData] = useState(workflowObject);

  const { ID } = useSelector((state) => state.memberDetails.activeBot);

  useEffect(() => {
    loader.start();

    if (!!workflowID) {
      setEditState(false);
    }

    axios({
      url: "/workflow/" + ID + "?workflow_id=" + workflowID,
    }).then((response) => {
      if (response.status) {
        setFormData(objectFromResponseData(response.data));
        loader.apiComplete();
      }
    });
  }, [ID, axios, workflowID, loader]);

  return (
    <Loader>
      <PageHeader pageName={"Workflow"} />
      <Form
        editState={editState}
        setEditState={setEditState}
        formData={formData}
      />
    </Loader>
  );
}
